import axios from 'axios/index'

// Separate, un-intercepted axios instance: this hits an internal AI service
// (different host than the main Snappy API), so it can't go through the
// shared `$api` instance — that one's interceptor stamps storeId/
// white-label-group-id headers meant for the main API onto every request.
const AI_UPSELLING_API = axios.create({
  baseURL: 'https://ai-profile.internal.gosnappy.io',
  // Personalized picks run an LLM server-side: 3-8s typical. axios' default is no
  // timeout, but the cart surface shows a skeleton while waiting, so cap it rather
  // than spinning forever on a wedged request.
  timeout: 30000
})

export function fetchUpsellRecommendations({ phone, storeId, mid, budget, count, authToken, orderType, cartItems, minItems }) {
  const payload = { phone, store_id: storeId }
  if (mid) payload.menu_code = mid
  if (budget) payload.budget = budget
  if (count) payload.count = count
  if (orderType) payload.order_type = orderType
  // Codes already in the cart: never returned, but their names go to the model so
  // the picks complement what's there. Re-requesting after each add is what
  // refreshes the list.
  if (cartItems && cartItems.length) payload.cart_items = cartItems
  // `!= null` rather than a truthy check: min_items: 0 is a legitimate value and a
  // truthy test would silently drop it.
  if (minItems != null) payload.min_items = minItems
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {}
  return AI_UPSELLING_API.post('/ai/upselling', payload, { headers }).then(res => res.data.recommendations || [])
}

// DEV-10387: anonymous fallback for logged-out guests -- last-7-days online best sellers
// at the store, no phone/auth needed, no LLM call (server-cached ~5min). Same response
// shape as /ai/upselling (see getAiRecommendationsCategory in menu.js), so both endpoints
// feed the same rendering path.
export function fetchPopularItems({ storeId, mid, count, orderType, cartItems, minItems }) {
  const params = { store_id: storeId }
  if (mid) params.menu_code = mid
  if (count) params.count = count
  if (orderType) params.order_type = orderType
  // GET takes cart_items comma-separated, unlike the POST body's array.
  if (cartItems && cartItems.length) params.cart_items = cartItems.join(',')
  if (minItems != null) params.min_items = minItems
  return AI_UPSELLING_API.get('/ai/popular-items', { params }).then(res => res.data.recommendations || [])
}
